import React from 'react';
import { Table } from 'new/elements/Table';
import { columns } from 'new/components/TeamsTable/columns';
import { Team } from 'new/entities/Team';
import { TableProps } from 'new/elements/Table/types';

interface TeamsTableProps {
  onClickTeam?: (team: Team) => void;
  teams: Team[];
}

export function TeamsTable(props: TeamsTableProps & Partial<TableProps<Team>>) {
  const { teams } = props;
  return (
    <Table
      onRowClick={props.onClickTeam}
      rowKeyExtractor={(row) => row.id}
      columns={columns}
      rows={teams}
      {...props}
    />
  );
}

TeamsTable.defaultProps = {
  teams: [],
};
